<template>
  <!-- Top -->
  <section class="product-top observable">
    <section class="product-top-top">
      <div class="page-head-bottom">
        <div class="wrap">
          <div class="page-head-bottom-item">
            <div class="name">
              <span class="big ft-26">{{$t('product.head[2]')}}</span>
              <span class="small ft-16">Flavor</span>
            </div>
            <div class="info ft-14">
              {{ flavor }}
            </div>
          </div>
          <div class="page-head-bottom-item">
            <div class="name">
              <span class="big ft-26">{{$t('product.head[3]')}}</span>
              <span class="small ft-16">Packing</span>
            </div>
            <div class="info ft-14">
              {{ packing }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="wrapper-1280 product-top-slider-container">
      <div class="product-top-slider-container-inner">
        <div class="product-top-slider"
          id="product-top-slider">
          <div v-for="item in imgs"
            :key="item.ID"
            class="product-top-slide img-lazyload-container">
            <img
              data-lazyload="true"
              class="img-lazyload"
              :src="item.PICURL | imgFilter">
          </div>
          <!-- <div class="product-top-slide img-lazyload-container">
            <img
              data-lazyload="true"
              class="img-lazyload"
              src="/images/slide1-2.jpg"
              alt="Chien de traineau en Laponie, Finlande"
              title="Chien"
            >
          </div>
          <div class="product-top-slide img-lazyload-container">
            <img
              data-lazyload="true"
              class="img-lazyload"
              src="/images/slide1-3.jpg"
              alt="Hébergements de Hossa"
              title="Hbergements"
            >
          </div>
          <div class="product-top-slide img-lazyload-container">
            <img
              data-lazyload="true"
              class="img-lazyload"
              src="/images/slide1-4.jpg"
              alt="vacances en Laponie en hiver"
              title="vacances"
            >
          </div> -->
          <!-- <div class="product-top-slide img-lazyload-container">
            <img
              data-lazyload="true"
              class="img-lazyload"
              src="/images/slide1-5.jpg"
              alt="Chien de traîneau en laponie"
              title="Chien"
            >
          </div> -->
        </div>
        <div class="product-top-slider-nav">
          <div class="slider-nav-buttons">
            <div class="slider-nav-item slider-nav-item-prev" id="product-top-slider-prev"
            @click="onPaginationPrev">
              <div class="slider-nav-item-icon-container">
                <span class="slider-nav-item-icon-1">
                  <svg class="icon icon-fleche">
                    <use xlink:href="#fleche"></use>
                  </svg>
                </span>
                <span class="slider-nav-item-icon-2">
                  <svg class="icon icon-fleche">
                    <use xlink:href="#fleche"></use>
                  </svg>
                </span>
              </div>
            </div>
            <div class="slider-nav-item slider-nav-item-next" id="product-top-slider-next"
            @click="onPaginationNext">
              <div class="slider-nav-item-icon-container">
                <span class="slider-nav-item-icon-1">
                  <svg class="icon icon-fleche">
                    <use xlink:href="#fleche"></use>
                  </svg>
                </span>
                <span class="slider-nav-item-icon-2">
                  <svg class="icon icon-fleche">
                    <use xlink:href="#fleche"></use>
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <div class="slider-nav-pagination">
            <span class="ff-tt ft-60 slider-nav-page">01</span>
            <span class="ff-tt ft-30 slider-nav-total">
              03
            </span>
          </div>

          <!-- Progress bar -->
          <div class="slider-progress slider-nav-progress" id="product-top-slider-progress">
            <div class="slider-progress-inner"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Slider from '@/n66/slider.js'
import {
  qs, qsa, domAddClass, domRemoveClass
} from '@/util/dom.js'
import { TweenMax, TimelineLite, TweenLite, Power3, Expo } from 'gsap/TweenMax'

export default {
  props: {
    flavor: String,
    packing: String,
    imgs: Array
  },

  // data () {
  //   return {
  //     total: 0
  //   }
  // },

  // computed: {
  //   t () {
  //     if (this.total < 10) {
  //       return `0${this.total}`
  //     }
  //     return this.total
  //   }
  // },

  beforeDestroy () {
    this.tlAutoplayTopSlider && this.tlAutoplayTopSlider.kill()
    this.tlAutoplayTopSlider = null
  },

  mounted () {
    this.autoplayTopSlider = true

    // this.init()
  },

  methods: {
    init () {
      this.initDOM()

      this.topSlider =
        new Slider('product-top-slider', this.onSliderTopChange, true, true)

      if (this.total === 0 || this.total === 1) {
        domAddClass(this.topSliderNav, 'disable')
      }

      this.setAutoSlideTopSlider()
    },

    initDOM () {
      this.DomTopSlider = qs('.product-top-slider', this.$el)
      this.firstSlide = qs('.product-top-slide', this.$el)
      this.topSlides = qsa('.product-top-slide', this.$el)
      this.topSliderNavPage = qs('.slider-nav-page', this.$el)
      this.topSliderNav = qs('.product-top-slider-nav', this.$el)
      this.sliderNavTotal = qs('.slider-nav-total', this.$el)

      this.DomTopSlider.setAttribute('data-total', this.imgs.length)
      domAddClass(this.firstSlide, 'active')

      const t = this.imgs.length > 10
        ? this.imgs.length
        : `0${this.imgs.length}`
      this.sliderNavTotal.innerHTML = t
    },

    setAutoSlideTopSlider () {
      this.tlAutoplayTopSlider = TweenMax.delayedCall(5, function () {
        this.autoplayTopSlider && this.slideTopSlider()
      }.bind(this))
    },

    slideTopSlider () {
      this.tlAutoplayTopSlider.kill()
      this.topSlider.next()
    },

    onSliderTopChange (t, e) {
      var i = this
      i.topSlider.canSlide = false
      i.tlAutoplayTopSlider && i.tlAutoplayTopSlider.kill()
      var n = qsa('.active', i.DomTopSlider)
      var r = i.topSlides[t]
      var o = qsa('.active img', i.DomTopSlider)
      var a = qs('img', r)
      var l = i.DomTopSlider.offsetHeight
      var h = new TimelineLite({
        onComplete: function () {
          domRemoveClass(n[0], 'active')
          domAddClass(r, 'active')
          i.topSlider.canSlide = true
          i.setAutoSlideTopSlider()
        }
      })

      h.to(n, 1, {
        opacity: 1,
        y: e * -l,
        ease: Power3.easeInOut
      }).to(o, 1, {
        opacity: 1,
        y: e * l / 1.5,
        ease: Power3.easeInOut
      }, 0)

      h.set(r, {
        opacity: 1,
        y: e * l
      }, 0).set(a, {
        opacity: 1,
        y: e * -l / 1.5
      }, 0).to(r, 1, {
        opacity: 1,
        y: 0,
        ease: Power3.easeInOut
      }, 0).to(a, 1, {
        opacity: 1,
        y: 0,
        ease: Power3.easeInOut
      }, 0)

      this.updateTopNavPage()
    },

    updateTopNavPage () {
      var t = this.topSlider.page + 1
      t < 10 && (t = '0' + t)
      TweenLite.to(this.topSliderNavPage, 0.8, {
        y: 80,
        ease: Expo.easeIn,
        onComplete: function () {
          this.topSliderNavPage.innerHTML = t
          TweenLite.set(this.topSliderNavPage, {
            y: -80,
            ease: Expo.easeOut
          })
          TweenLite.to(this.topSliderNavPage, 0.8, {
            y: 0,
            ease: Expo.easeOut
          })
        }.bind(this)
      }, 0)
    },

    onPaginationNext () {
      console.log('onPaginationNext')
      this.topSlider.sens = 1
      this.topSlider.set()
    },

    onPaginationPrev () {
      console.log('onPaginationPrev')
      this.topSlider.sens = -1
      this.topSlider.set()
    }
  }
}
</script>

<style lang="scss" scoped>
.product-top {
  padding-top: 40px;
  font-size: 0;
  line-height: 0;
  position: relative;
  // padding-bottom: 80px;
  background-color: #242a3a;
  background: url(/images/pattern-blue.jpg) repeat;
}

.product-top-top {
  position: relative;
  height: 128px;
}

.page-head-bottom {
  font-size: 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  max-width: 1280px;
  z-index: 3;
  left: 50%;
  box-sizing: border-box;
  transform: translateX(-50%);

  .wrap {
    width: 100%;
    display: flex;
  }
}

.page-head-bottom-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 32px;

  .name {
    color: #c5e3f7;
    display: flex;
    align-items: baseline;

    span {
      display: inline-block;
      padding: 16px 4px;
    }
  }
  .info {
    padding: 4px;
    color: #fff;
    line-height: 32px;
  }
}

.slider-nav-buttons {
  position: relative;
  padding-top: 145px;
}

.slider-nav-item {
  display: block;
  margin: 0 auto;
  width: 60px;
  height: 60px;
  position: relative;
  margin-bottom: 16px;
  -webkit-transition: opacity 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
}

.slider-nav-item:after,
.slider-nav-item:before {
  content: "";
  display: block;
  border: 4px solid #2e3448;
  border-radius: 100%;
  position: absolute;
  width: 52px;
  height: 52px;
  left: 0;
  top: 0;
}

.slider-nav-item:before {
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
}

.slider-nav-item:after {
  border-color: #96daf0;
  opacity: 0;
  -webkit-transform: scale(1.3);
  transform: scale(1.3);
  -webkit-transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slider-nav-item-icon-container {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 52px;
  height: 52px;
  border-radius: 100%;
  overflow: hidden;
}

.slider-nav-item .icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -8px;
  margin-left: -8px;
  width: 16px;
  height: 16px;
  fill: #fff;
  -webkit-transition: -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-nav-item-icon-1,
.slider-nav-item-icon-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 1;
  -webkit-transition: opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s;
  transition: transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s,
    opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s,
    opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.77, 0, 0.175, 1) 0s;
}

.slider-nav-item-icon-2 {
  opacity: 0;
  -webkit-transform: translateX(-80px);
  transform: translateX(-80px);
  -webkit-transition: opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
  transition: transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    opacity 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s,
    -webkit-transform 0s cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
}

.slider-nav-item-prev .icon {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.slider-nav-item-prev .slider-nav-item-icon-2 {
  -webkit-transform: translateX(80px);
  transform: translateX(80px);
}

.slider-nav-item:hover:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 50ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 50ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 50ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms;
  transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 50ms,
    transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms,
    -webkit-transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 50ms;
}

.slider-nav-item:hover:before {
  opacity: 0;
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  -webkit-transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    -webkit-transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slider-nav-item:hover .slider-nav-item-icon-1 {
  opacity: 0;
  -webkit-transform: translateX(80px);
  transform: translateX(80px);
  -webkit-transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
}

.slider-nav-item:hover .slider-nav-item-icon-2 {
  opacity: 1;
  -webkit-transform: translateX(0);
  transform: translateX(0);
  -webkit-transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1),
    -webkit-transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
}

.slider-nav-item-prev:hover .slider-nav-item-icon-1 {
  -webkit-transform: translateX(-80px);
  transform: translateX(-80px);
}

.slider-nav-pagination {
  display: block;
  color: #fff;
  position: relative;
  margin-top: 60px;
  overflow: hidden;
  height: 50px;
  padding-top: 16px;
  padding-bottom: 16px;
  box-sizing: content-box;
}

.slider-nav-page {
  color: #fff;
  width: 85px;
  line-height: 50px;
  display: inline-block;
  text-align: center;
  margin-left: -42px;
}

.slider-nav-total {
  color: #2e3448;
  display: inline-block;
}

.slider-nav-progress {
  width: 160px;
  height: 2px;
  background-color: #2e3448;
  position: relative;
  margin-top: 0;
}

.slider-nav-progress-bar {
  background-color: #96daf0;
  height: 2px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  -webkit-transition: width 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: width 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-nav-progress-bar.complete-right {
  right: 0;
  left: auto;
  -webkit-transition: width 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: width 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.slider-nav-progress-bar.complete-left {
  left: 0;
  -webkit-transition: width 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: width 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

@media (max-width: 960px) {
  .slider-nav {
    width: 100%;
    height: 290px;
    position: relative;
    top: 180px;
  }

  .slider-nav-buttons,
  .slider-nav-pagination {
    display: none;
  }

  .slider-nav-container {
    max-width: 100%;
    width: 100%;
    padding: 0;
  }

  .slider-nav-progress {
    position: absolute;
    bottom: 30px;
    left: 50%;
    margin-left: -40px;
    width: 80px;
  }

  .slider-selection-slides {
    top: 0;
    margin-top: 0;
    left: 50%;
    margin-left: -202px;
  }
}

.wrapper-1280 {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
}

.product-top-slider-container-inner {
  position: relative;
  top: 260px;
  margin-top: -150px;
}

.product-top-slider {
  position: relative;
  height: 0;
  // padding-bottom: 41.8%;
  padding-bottom: 48.125%;
  overflow: hidden;
  background-color: #96daf0;
}

.product-top-slide {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  overflow: hidden;
}

.product-top-slide.active {
  opacity: 1;
}

.product-top-slide img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.product-top-slider-nav {
  display: block;
  position: absolute;
  z-index: 10;
  bottom: 50px;
  left: 30px;
  text-align: center;
}

.product-top-slider-nav.disable .slider-nav-item {
  opacity: 0.4;
  pointer-events: none;
}

.product-top-slider-nav .slider-nav-buttons {
  margin-left: -40px;
}

.product-top-slider-nav .slider-nav-item:before {
  opacity: 0.2;
  border-color: #fff;
}

.product-top-slider-nav .slider-nav-item:hover:before {
  opacity: 0;
}

.product-top-slider-nav .slider-nav-total {
  color: #fff;
  opacity: 0.2;
}

.product-top-slider-nav .slider-nav-progress {
  width: 120px;
  background-color: rgba(255, 255, 255, 0.2);
}

.product-top-slider-nav .slider-nav-page {
  margin-left: -12px;
}

.product-top-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.animate .product-top .page-head-bottom-item:after {
  opacity: 0;
}

.animate .product-top .page-head-bottom-item-txt {
  opacity: 0;
  -webkit-transform: translateY(80px);
  transform: translateY(80px);
}

.animate .product-top .page-head-bottom-item-icon {
  -webkit-transform: translateY(80px);
  transform: translateY(80px);
}

.animate .product-top .page-head-bottom-item-icon:before {
  opacity: 0;
  -webkit-transform: scale(1.4);
  transform: scale(1.4);
}

.animate .product-top .page-head-bottom-item-icon .icon {
  opacity: 0;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.animate .product-top.visible .page-head-bottom-item:after {
  opacity: 0.1;
  -webkit-transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.animate .product-top.visible .page-head-bottom-item-txt {
  opacity: 1;
  -webkit-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    -webkit-transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    -webkit-transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.animate .product-top.visible .page-head-bottom-item-icon {
  -webkit-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition: -webkit-transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: -webkit-transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.animate .product-top.visible .page-head-bottom-item-icon:before {
  opacity: 0.2;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.animate .product-top.visible .page-head-bottom-item-icon .icon {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    -webkit-transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    -webkit-transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: opacity 1s cubic-bezier(0.455, 0.03, 0.515, 0.955),
    transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    -webkit-transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.animate .product-top.visible .page-head-bottom-item:nth-child(1):after {
  -webkit-transition-delay: 0s;
  transition-delay: 0s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(1)
  .page-head-bottom-item-icon {
  -webkit-transition-delay: 0s;
  transition-delay: 0s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(1)
  .page-head-bottom-item-txt {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(1)
  .page-head-bottom-item-icon:before {
  -webkit-transition-delay: 0.3s;
  transition-delay: 0.3s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(1)
  .page-head-bottom-item-icon
  .icon {
  -webkit-transition-delay: 0s;
  transition-delay: 0s;
}

.animate .product-top.visible .page-head-bottom-item:nth-child(2):after {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(2)
  .page-head-bottom-item-icon {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(2)
  .page-head-bottom-item-txt {
  -webkit-transition-delay: 0.35s;
  transition-delay: 0.35s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(2)
  .page-head-bottom-item-icon:before {
  -webkit-transition-delay: 0.5s;
  transition-delay: 0.5s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(2)
  .page-head-bottom-item-icon
  .icon {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}

.animate .product-top.visible .page-head-bottom-item:nth-child(3):after {
  -webkit-transition-delay: 0.4s;
  transition-delay: 0.4s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(3)
  .page-head-bottom-item-icon {
  -webkit-transition-delay: 0.4s;
  transition-delay: 0.4s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(3)
  .page-head-bottom-item-txt {
  -webkit-transition-delay: 0.55s;
  transition-delay: 0.55s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(3)
  .page-head-bottom-item-icon:before {
  -webkit-transition-delay: 0.7s;
  transition-delay: 0.7s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(3)
  .page-head-bottom-item-icon
  .icon {
  -webkit-transition-delay: 0.4s;
  transition-delay: 0.4s;
}

.animate .product-top.visible .page-head-bottom-item:nth-child(4):after {
  -webkit-transition-delay: 0.6s;
  transition-delay: 0.6s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(4)
  .page-head-bottom-item-icon {
  -webkit-transition-delay: 0.6s;
  transition-delay: 0.6s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(4)
  .page-head-bottom-item-txt {
  -webkit-transition-delay: 0.75s;
  transition-delay: 0.75s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(4)
  .page-head-bottom-item-icon:before {
  -webkit-transition-delay: 0.9s;
  transition-delay: 0.9s;
}

.animate
  .product-top.visible
  .page-head-bottom-item:nth-child(4)
  .page-head-bottom-item-icon
  .icon {
  -webkit-transition-delay: 0.6s;
  transition-delay: 0.6s;
}

.animate .product-top.visible:after {
  opacity: 1;
  -webkit-transition: opacity 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  transition: opacity 0.8s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}
@media(max-width: 768px){
  .product-top-top{
    height: auto;
  }
  .page-head-bottom{
    position: static;
    transform: translate(0);
    .wrap{
      flex-direction: column;
    }
  }
  .product-top-slider-nav{
    position: static;
    .slider-nav-buttons{
      display: flex;
      margin: 0;
      padding-top: 0;
      .slider-nav-item{
        &:after,
        &:before{
          border-color: #000;
        }
        .icon{
          fill: #000;
          opacity: .2;
          transition: .4s;
        }
        &:hover .icon{
          opacity: 1;
        }
      }
    }
  }
}
</style>
